import { gql, useLazyQuery } from "@apollo/client";
export const GET_SCHEMA_LIST = gql`
  query getCdlSchemaList($catalogName: String!) {
    getCdlSchemaList(input: { catalogName: $catalogName }) {
      name
      fullName
      updatedAt
      updatedBy
      createdAt
      createdBy
    }
  }
`;

export function useGetCdlSchemaList() {
  const [
    getCdlSchemaList,
    { data: schemaList, loading: isLoadingSchemaList, error: errorSchemaList }
  ] = useLazyQuery(GET_SCHEMA_LIST);
  return {
    getCdlSchemaList,
    schemaList,
    isLoadingSchemaList,
    errorSchemaList
  };
}
